import { useLocation } from "react-router-dom";
import { PostHogSnippet } from "./PostHogSnippet";
import { MetaPixelSnippet } from "./MetaPixelSnippet";

export const AnalyticsWrapper = () => {
  const location = useLocation();
  
  // Exclude all /admin paths from analytics
  if (location.pathname.startsWith("/admin")) {
    return null;
  }
  
  return (
    <>
      <PostHogSnippet />
      <MetaPixelSnippet />
    </>
  );
};
